import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { SETTINGS_SECTIONS } from '@/components/shell/navigation';
import { PageHeader } from '@/components/shell/page-header';

export const Route = createFileRoute('/_app/settings')({
  component: SettingsLayout,
});

/** Settings: copy trading, account and engine status, one section per tab. */
function SettingsLayout() {
  return (
    <>
      <PageHeader title="Settings" />
      <nav
        aria-label="Settings sections"
        className="-mt-1 mb-5 flex gap-1 overflow-x-auto border-b border-hairline"
      >
        {SETTINGS_SECTIONS.map((section) => (
          <Link
            key={section.to}
            to={section.to}
            title={`${section.label} (G then ${section.hotkey.toUpperCase()})`}
            className="relative -mb-px shrink-0 border-b-2 border-transparent px-3 pt-1 pb-2.5 text-[0.8125rem] font-medium text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring data-[status=active]:border-foreground data-[status=active]:text-foreground"
          >
            {section.label}
          </Link>
        ))}
      </nav>
      <Outlet />
    </>
  );
}
